import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../Components/BreadCrumb";
// import InnerBanner from "../Components/InnerBanner";
import Spinner from "../Components/Spinner";
import { flattenMenus } from "../../../Utility/FlattenMenu";
import { useGetMenusDataQuery } from "../../../redux/services/internal/apiHome";
// import useParsedHtml from "../../../hooks/useParsedHtml";

export const replaceBaseUrl = (html = "") => {
  const baseUrl = process.env.REACT_APP_API_IMAGE_URL;
  if (!html || !baseUrl) return html;
  return html.replace(
    /https?:\/\/[^/]+\/rct_application/g,
    `${baseUrl}/rct_application`,
  );
};

const MenuPage = ({ benchId }) => {
  const location = useLocation();
  const path = location.pathname;
  const menuPath = path.split("/").pop();

  const [filteredMenu, setFilteredMenu] = useState([]);

  // Fetch data from the API
  const { data: fetchedData = {}, isLoading } = useGetMenusDataQuery(benchId, {
    refetchOnMountOrArgChange: true,
  });

  const transformedData = useMemo(() => {
    return fetchedData.data ? flattenMenus(fetchedData.data) : [];
  }, [fetchedData.data]);

  useEffect(() => {
    if (transformedData.length > 0) {
      const filteredPageData = transformedData.filter(
        (item) => item.slug === menuPath,
      );
      // console.log(filteredPageData)
      setFilteredMenu(filteredPageData);
    }
  }, [transformedData, menuPath]);

  // const htmlDescription = filteredMenu[0]?.description;

  // const { formattedHtml, dom, isValid } = useParsedHtml(htmlDescription);

  // useEffect(() => {
  //   if (isValid) {
  //     console.log("Formatted HTML:");
  //     console.log(formattedHtml);
  //   }
  // }, [formattedHtml, dom, isValid]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        {filteredMenu.length > 0 ? (
          <>
            {filteredMenu.map((item, index) => (
              <React.Fragment key={index}>
                {/* <InnerBanner title={filteredMenu[0].title || "Default Title"} /> */}
                <BreadCrumb title={filteredMenu[0].title || "Default Title"} />
                <div className="about-bg inner-page-section">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: replaceBaseUrl(item?.description),
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </>
  );
};

export default MenuPage;
